import React from "react";
import './Header.scss'
import DefaultCard from "../../atoms/DefaultCard/DefaultCard";
import ButtonBack from "../../atoms/ButtonBack/ButtonBack";
import { useLocation, useNavigate } from "react-router-dom";
import iconHamburguesa from '../../../assets/icons/menuHamburguesa.svg'
import { desEncriptar, encriptar } from "../../../utilidades/encriptacion";
import menuHamburguesa from '../../../assets/icons/menuHamburguesa.svg'
import logout from '../../../assets/icons/logout.svg'
import { useMenu } from "../../../context/MenuContext";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION

const Header = ({ setAuth, setCambioDeMenu, setMostrarMenu, mostrarMenu, sizing, id, setOcultarMenuMovil, ocultarMenuMovil }) => {
    const navigate = useNavigate()
    const ruta = useLocation()
    const { menuData } = useMenu();

    const cerrarSesion = () => {
        const auth = encriptar("false", key)
        sessionStorage.setItem("auth", auth)
        navigate("/")
        window.location.reload()
    }
    const getEnvironmentInfo = () => {
        try {
            const env = JSON.parse(desEncriptar(sessionStorage.getItem('dataClient'), key));
            return env?.environment;
        } catch (error) {
            console.error('Error al obtener información del entorno:', error);
            return null;
        }
    };

    const isTestingEnvironment = getEnvironmentInfo() === 'SUMA_TESTING';

    const getCurrentPageTitle = () => {
        // Verificar si es la página de editar usuario
        if (ruta.pathname === "/editar-usuario") {
            return "EDITAR PERFIL";
        }

        // Buscar en el menú principal
        for (const item of menuData) {
            if (item.url === ruta.pathname) {
                return item.title.toUpperCase();
            }

            // Buscar en submenús
            if (item.subMenu?.length > 0) {
                for (const subItem of item.subMenu) {
                    if (subItem.url === ruta.pathname) {
                        return subItem.title.toUpperCase();
                    }
                }
            }
        }

        return ""; // Retorna vacío si no encuentra coincidencia
    };

    return (
        <div className="Header" onMouseMove={() => setCambioDeMenu(false)}>
            <DefaultCard padding={false}>
                <div className="headerStructure">
                    {/* Sección izquierda - Navegación */}
                    {sizing.width < 1024 ? (
                        <div className="menuHamburguesa">
                            <div className="imagenContenedor">
                                <img
                                    src={iconHamburguesa}
                                    alt="Menú"
                                    onClick={() => setOcultarMenuMovil(!ocultarMenuMovil)}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="backButton">
                            <div className="contenedorHamburguesa">
                                <img
                                    className="haburguesa"
                                    src={menuHamburguesa}
                                    onClick={() => setMostrarMenu(!mostrarMenu)}
                                    alt="Menú"
                                />
                            </div>
                            <ButtonBack onClick={() => navigate(-1)} />
                        </div>
                    )}

                    {/* Sección central - Título de la página */}
                    <div className="pageTitle">
                        <h1 className="titleText">
                            {getCurrentPageTitle()}
                        </h1>
                    </div>

                    {/* Sección derecha - Opciones de usuario */}
                    <div className="userOptions">
                        {/* Indicador de entorno de testing */}
                        {isTestingEnvironment && (
                            <div className="environmentIndicator">
                                <span className="testingBadge">
                                    SUMA_TESTING
                                </span>
                            </div>
                        )}

                        {/* Opciones de usuario */}
                        <div className="user">
                            <span className="logoutText">Cerrar sesión</span>
                            <img
                                src={logout}
                                width="30"
                                className="logoutIcon"
                                onClick={cerrarSesion}
                                alt="Cerrar sesión"
                            />
                        </div>
                    </div>
                </div>
            </DefaultCard>
        </div>
    )
}

export default Header